(ns frontend.view.components.form.person-to-guest.person-account-card
  (:require
   [common.localization :as loc]
   [reagent.core :as r]
   [common.entity :as entity]
   [frontend.view.modals.events :as modals]
   [frontend.view.modals.confirmation.view :as confirmation]
   [frontend.state.current-session :as session]
   [ui.components.button.view :as button]))

(defn person-line
  [{:keys [account re-invite-guest!]}]
  (let []
    [:span
     {:class "flex items-center justify-between gap-2"}
     [:span
      (entity/display-string account :long)]
     (when-not (session/is-read-only-user?)
       [button/square-secondary-open
        {:tooltip (loc/tr :resend-invitation)
         :on-click   (fn [e]
                       (re-invite-guest!))}
        [:i.fal.fa-repeat]])]))

(defn invited-person
  [{:keys [person-id associated-account target re-invite-guest! remove-guest!]}]
  "For persons for who accounts have already been created"
  (let [on-remove! (partial modals/open-modal!
                            confirmation/modal-key
                            {:body           [:div (loc/tr :guest/delete-guest-info)
                                              [:p (loc/tr :i-understand-that)]]
                             :confirms       [[:tasks
                                               (loc/tr (if (-> target
                                                           :entity/type
                                                           (= :entity.type/oppo))
                                                     :guest/tasks-info-deal
                                                     :guest/tasks-info))]]
                             :checkbox-class "guest-checkbox"
                             :body-class     "guest-confirm-body"
                             :confirm-text   (loc/tr :guest/remove-access-right)
                             :checkbox-text  (loc/tr :there-is-no-undo-for-this)
                             :on-confirm     remove-guest!})]
    [:div
     
     [:div
      {:class "px-3 py-2 flex justify-between gap-2 items-center bg-base-light border border-solid border-base-light-border-paler rounded"}
      [person-line
       {:account associated-account ;; can also use account here
        :re-invite-guest! re-invite-guest!}]
      (when-not (session/is-read-only-user?)
        [button/square-secondary-open
         {:tooltip  (loc/tr :remove-guest)
          :on-click   (fn [e]
                        (.stopPropagation e)
                        (on-remove!))}
         [:i.fal.fa-times]])]
    ]))
